export const environment = {
  appVersion: '1.2',
  addressVersionUrl: 'https://bff.nad-experimental-e3.com/v1/backend/file?name=system/namie-version.json',
  /** PWA更新中タイムアウト(ms) */
  pwaUpdatingTimeout: 1000 * 15,

  /** PWA関連のモーダル最短表示時間(ms) */
  pwaDisplayTimeout: 1000 * 2,

  /** PWA更新確認中の操作無効化(true:操作可, false:操作不可) */
  operationDuringPwaUpdate: false,

  /* 環境種別 */
  type: 'spoke',

  token: null,
  bookingCode: null,
  bookingCheckUrl: 'https://bff.nad-experimental-e3.com/booking-check/',

  /* Spare接続先環境 開発(dev) or 実証実験(prd) */
  profile: 'dev',

  /** Spare環境毎のサービスID */
  spareServices: {
    /** Spare開発環境サービスID */
    dev:  [
      'abc715f4-109c-4c2a-84ec-7f315fb90824'  //サービス名：なみえスマートモビリティ
    ],
    /** Spare実証実験環境サービスID */
    prd: [
      '61d76d3b-46dc-4378-a41a-95fab65b7192'  //サービス名：なみえスマートモビリティ
    ]
  },

  setting: {
    /** サービサーURL. */
    servicerApiUrl: 'https://bff.nad-experimental-e3.com',

    /** 言語. */
    language: 'ja',
    /** 施設ID. */
    facilityId: null,
    /** ステーションコード. */
    stationCode: '',
    /** 満空機能の有効化(trueで有効). */
    isOnFacility: false,
    /** 施設詳細画面の表示(trueで表示). */
    isShowFacilityDetail: false,
    /** 満空情報値を簡単に表示するかどうかのフラグ(休業中、準備中、営業中). */
    isSimpleDisplayVacancyStatus: false,
    /** 自動起動（保存した設定でアプリが起動）. */
    autostart: true,

    /** 予約キャンセル許容時間(単位:ms) */
    reservationCancelAllowTime: 180000,

    /** 配車待ち許容時間(単位:ms) */
    waitingAllowTime: 10000,

    /** エリアインデックス. */
    areaIndex: 1,
    /** サウンド. */
    sound: true,
    /** 顔認証するまでの待ち時間（単位：ms）. */
    faceLoginWaitingTime: 4000,
    /** 待ち受け画面の表示待ち時間（単位：ms）. */
    showWaitingScreenWaitingTime: 300000,
    /** 予約完了後の予約詳細表示画面の表示待ち時間（単位：ms）. */
    reservationWaitingTime: 60000,
    /** 予約キャンセル画面の待ち時間（単位：ms）. */
    cancelMessageWaitingTime: 3000,
    /** 予約一覧を取得する間隔（単位：ms）. */
    reservationsGetInterval: 1000,
    /** サーバーキャッシュ自動更新の間隔. */
    serverCacheUpdateMode: 0,
    /** デフォルト乗車人数. */
    defaultRideCount: 1,
    /** 最小乗車人数. */
    minRideCount: 1,
    /** 最大乗車人数. */
    maxRideCount: 9,
    /** 店舗指定 */
    assignName: '',
    /** 表示店舗名. */
    displayName: ''
  },
  /** エリアリスト. */
  areas: [
    {
      name: 'NATC'
    },
    {
      name: '浪江'
    }
  ],
  /** サービサーURLリスト. */
  servicerApiUrls: [
    'https://bff.nad-experimental-e3.com',
    'http://localhost:8081'
  ],

  /** ファイル取得URL. */
  backendFileUrl: '/v1/backend/file?name=',

  timeScheduleUrl: 'system/opening_hours.txt',

  /**
   * ホーム画面メッセージ取得先URL.
   *
   * - 本番リリース時 :
   */
  addressMessageBoardUrl: 'https://bff.nad-experimental-e3.com/v1/backend/file?name=system/message_board_minidigistop.html',

  /** 住所リストURL. */
  stationCsvUrl: 'data.csv',

  stopPointImageUrl: 'stop_point/img/',

  vehicleImageUrl: 'vehicle/img/',

  /* マップの切り替え.
  *
  * - none : マップ使用しない
  * - osm : OpenStreetMap
  * - google : Google Map
  *    `index.html` に `<script src="https://maps.googleapis.com/maps/api/js?key=${GoogleMapApikey}" async defer></script>` を指定してください。
  */
  map: 'google',
  /** 歩行速度（単位 : km/h）デフォルト : 4.8km/h（時速） ※分速の場合、80m/min */
  walkVelocity: 4.8,

  /** ServiceWorkerModule の登録.（PWA 実行時に true） */
  serviceWorkerRegister: true,

  /** 地図初期表示（ズーム）. */
  mapInitialStateZoom: 20,

  constTables: {
    userStations: null,
    timeSchedule: null,
    dataCsv: null,
    nextLoadDate: 0
  },

  currentGuest: null,

  buildVersion: "2608030808",

  pageReloading: false,

  /** 満空情報取得APIを呼び出しのフラグ */
  callAPiFlg: true,

  /** 満空情報状態画像パス */
  vacancySystemImageBasePath: 'assets/img/facility-status/',
  /** 施設詳細画像パス */
  facilityImageBasePath: 'facility/img/',
  /** 満空情報状態画像ファイル拡張子 */
  vacancySystemImageExtension: '.png',
};
